// Общее дерево приложения для ClientApp и ServerApp.
// Структура на сервере и клиенте должна совпадать, иначе гидрация падает (React error #418/#423),
// а useId выдаёт разные id.
import React, {useEffect} from 'react';
import {withRouter, useLocation} from 'react-router-dom';
import Routes from '../routes/routes';
import Auth from '../components/Auth';

const
  _ScrollToTop = (props) => {
    const {pathname} = useLocation();

    useEffect(() => {
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    }, [pathname]);
    return props.children;
  },
  ScrollToTop = withRouter(_ScrollToTop);

const AppRoutes = () => (
  <ScrollToTop>
    <Routes />
    <Auth />
  </ScrollToTop>
);

export default AppRoutes;
